export default __webpack_public_path__ + "a08a52e7b15ea98518c050c9aa4f3098.jpg";